import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from '../../../components/Card';
import { deriveCashSeries } from '../engine/cashSeries';
import { formatSwissAmount } from '../billing/formatSwiss';

// Charges personnel — mode « Connecté à People » (lecture seule).
// Recopie la vue des charges de personnel du plan sur la fenêtre de projection
// (12 mois à venir), à partir de la projection dérivée des contrats / plan RH.
// Utilise la MÊME dérivation (deriveCashSeries) que le Graphique → chiffres
// garantis identiques.
const num = (v) => Number(v) || 0;

export default function PersonnelProjectionView({
  scenario, calc, revenues = [], variables = [], personnelProjection,
  chargesSocialesMonthly, assurancesMonthly, annualExtrasMonthly,
  bsLiquidityByYear, horizon,
}) {
  const { t } = useTranslation();
  if (!calc) {
    return (
      <Card title={t('phrases:p_3889c07832')}>
        <p className="tres-section-subtitle">Calcul indisponible (scénario vide ?).</p>
      </Card>
    );
  }

  let s;
  try {
    s = deriveCashSeries({
      scenario, calc, revenues, variables,
      personnelProjection, chargesSocialesMonthly, assurancesMonthly, annualExtrasMonthly,
      bsLiquidityByYear, horizon,
    });
  } catch (e) {
    return (
      <Card title={t('phrases:p_3889c07832')}>
        <p className="tres-section-subtitle">Erreur de calcul : {e.message}</p>
      </Card>
    );
  }

  const { monthLabels = [], salairesNets = [], csTotalMonthly = [], assurances = [],
    extrasMonthly = [], varCompMonthly = [], bonusMonthly = [] } = s;
  const n = monthLabels.length;
  const idx = Array.from({ length: n }, (_, i) => i);

  // Lignes affichées (une par composante) + total mensuel.
  const rows = [
    { key: 'net',   label: 'Salaires nets',          vals: salairesNets },
    { key: 'cs',    label: 'Charges sociales',        vals: csTotalMonthly },
    { key: 'assur', label: 'Assurances',              vals: assurances },
    { key: 'extra', label: t('phrases:p_b19f4ef2b2'),   vals: extrasMonthly },
    { key: 'var',   label: 'Variation / bonus',       vals: idx.map((i) => num(varCompMonthly[i]) + num(bonusMonthly[i])) },
  ];
  const totalMonthly = idx.map((i) => rows.reduce((a, r) => a + num(r.vals[i]), 0));
  const rowTotal = (vals) => idx.reduce((a, i) => a + num(vals[i]), 0);
  const grandTotal = idx.reduce((a, i) => a + totalMonthly[i], 0);

  return (
    <Card title={t('phrases:p_3889c07832')} subtitle={t('phrases:p_73addca95d')}>
      <div className="tres-table-wrap" style={{ overflowX: 'auto' }}>
        <table className="page-table">
          <thead>
            <tr>
              <th style={{ textAlign: 'left', minWidth: 170 }}>Charges de personnel</th>
              {monthLabels.map((m, i) => <th key={i} style={{ textAlign: 'right' }}>{m}</th>)}
              <th style={{ textAlign: 'right' }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.key}>
                <td style={{ textAlign: 'left' }}>{r.label}</td>
                {idx.map((i) => <td key={i} style={{ textAlign: 'right' }}>{num(r.vals[i]) ? formatSwissAmount(num(r.vals[i])) : '–'}</td>)}
                <td style={{ textAlign: 'right', fontWeight: 600 }}>{formatSwissAmount(rowTotal(r.vals))}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="lk-hi-strong">
              <td style={{ textAlign: 'left', fontWeight: 700 }}>Total charges personnel</td>
              {idx.map((i) => <td key={i} style={{ textAlign: 'right', fontWeight: 700 }}>{formatSwissAmount(totalMonthly[i])}</td>)}
              <td style={{ textAlign: 'right', fontWeight: 700 }}>{formatSwissAmount(grandTotal)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </Card>
  );
}
